<template>
  <div class="security">
    <div class="security_top">
      <van-icon
        style="position: absolute; left: 10px"
        size="25"
        name="arrow-left"
        @click="to()"
      />
      <div class="my">账号与安全</div>
    </div>
    <div class="security_bottm">
      <van-cell-group inset>
        <van-cell title="手机号" is-link to="replacephone" :value="username" />
        <van-cell title="修改密码" is-link @click="getCode" />
        <van-cell v-if="hasLogout " title="账号注销" is-link to="logoff" />
      </van-cell-group>
    </div>
  </div>
</template>

<script>
import { Dialog } from "vant";
export default {
  name: "security",
  components: {
    [Dialog.Component.name]: Dialog.Component,
  },
  data() {
    return {
      username: "",
      phone: "",
      hasLogout: true,
    };
  },
  created() {
    const information = JSON.parse(sessionStorage.getItem("userInfo"));
    this.username = information.user.username.replace(
      /(\d{3})\d{4}(\d{4})/,
      "$1****$2"
    );
    this.hasLogout = information.user.customerType != 4 && information.user.customerType != 5
    this.phone = information.user.username;
  },
  methods: {
    to() {
      window.history.go(-1);
    },
    getCode() {
      Dialog.confirm({
        message: `将给手机号${this.username}发送验证码`,
      }).then(() => {
        this.$router.push({
          path: "/changepassword",
          query: { phone: this.phone },
        });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.security {
  width: 100vw;
  min-height: 100vh;
  overflow: hidden;
  background: #f5f5f5;
  box-sizing: border-box;
  .security_top {
    height: 44px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #fff;
    line-height: 44px;
    .my {
      width: 100px;
      font-size: 18px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
      background: #fff;
      margin: 0 auto;
    }
  }
  .security_bottm {
    margin-top: 13px;
    .van-cell-group--inset {
      margin: 0px 12px;
    }
  }
}
</style>
